import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { createProvider, Step } from '../../../../shared/IFE/step/step/step';
import { UntypedFormBuilder } from '@angular/forms';
import { MetaSteps } from '../../models/constants';
import { PersonalDetailsSteps } from './models/personal-details-steps';
import { takeUntil } from 'rxjs/operators';
import { AnalyticsService } from '../../../../shared/modules/analytics/services/analytics.service';

@Component({
  selector: 'evc-quote-personal-details',
  providers: [createProvider(PersonalDetailsComponent)],
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalDetailsComponent extends Step implements OnInit {
  @Input() activeStep: PersonalDetailsSteps | MetaSteps;
  @Output() stepNavigation: EventEmitter<string> = new EventEmitter<string>();

  readonly personalDetailsSteps = PersonalDetailsSteps;

  readonly formName = 'evcQuote';
  readonly stepName = 'personal-details';

  constructor(fb: UntypedFormBuilder, analyticsService: AnalyticsService) {
    super(fb, analyticsService);
  }

  ngOnInit(): void {
    this.buildForm();
    // If we have first metadata set to first step.
    this.activeStep = this.activeStep === MetaSteps.first ? PersonalDetailsSteps.contactDetails : this.activeStep;

    // If the activeStep contains the last metadata we set the last step active.
    this.activeStep = this.activeStep === MetaSteps.last ? PersonalDetailsSteps.remarks : this.activeStep;
  }

  goToStep(step: PersonalDetailsSteps) {
    this.stepNavigation.emit(step);
    this.activeStep = step;
  }

  protected buildForm() {
    this.control = this.fb.group({
      contactDetails: [],
      existingClient: [],
      remarks: [],
    });

    this.control.valueChanges.pipe(takeUntil(this.notifier)).subscribe(() => {
      this.onModelChange(this.control.value);
      this.onTouch();
    });
  }
}
